var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 226,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187 113.419c0 11.11-2.44 21.64-6.83 31.09-11.73 25.35-37.39 42.91-67.17 42.91-29.77 0-55.43-17.56-67.17-42.91-4.39-9.45-6.83-19.98-6.83-31.09 0-40.88 33.12-74 74-74 40.89 0 74 33.12 74 74z",
    fill: "#F0F1F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.999 65v83.526l-36 18.474H94.795L56 149V41a2 2 0 0 1 2-2h85v24a2 2 0 0 0 2 2h23.999z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169 65h-24a2 2 0 0 1-2-2V39l26 26z",
    fill: "#D2D5D9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 52h22",
    stroke: "#336FB2",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.999 65H71v34h34l-.001-34zm0 45H71v34.001h34L104.999 110z",
    fill: "#E8E9EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120 77h31",
    stroke: "#D2D5D9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120 86h16",
    stroke: "#E8E9EB",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119 121h24",
    stroke: "#D2D5D9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119 130h32",
    stroke: "#E8E9EB",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.112 114 96 130H80l3.053-16h10.059z",
    fill: "#EC856F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m96 130-3 10H83l-3-10h16z",
    fill: "#DE6A5A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100 77c0 1.58-.406 2.616-.962 4H75.963c-.556-1.384-.962-2.42-.962-4h25z",
    fill: "#399C97"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99 81c-1.804 5.271-6.271 9-11.5 9-5.228 0-9.696-3.73-11.5-9h23z",
    fill: "#7FBEC6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.418 174.422h37.5c1.1 0 2-.9 2-2v-1h-6.94c-.86 0-1.62-.55-1.9-1.37l-7.09-21.27a2 2 0 0 0-1.9-1.37h-30.17l6.5 25c0 1.11.9 2.01 2 2.01z",
    fill: "#B6BABF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.918 163.422h-68v13h68v-13z",
    fill: "#5AB2AC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M178.657 147.419c-2.68 5.18-5.96 10-9.74 14.38l-1.44 1.62c-13.53 14.75-32.97 24-54.56 24-21.59 0-41.03-9.25-54.56-24l-1.44-1.62c-3.78-4.38-7.06-9.2-9.74-14.38h42.3c.86 0 1.62.55 1.9 1.37l7.09 21.27a2 2 0 0 0 1.9 1.37h29.12c.86 0 1.62-.55 1.9-1.37l7.09-21.27a2 2 0 0 1 1.9-1.37h38.28z",
    fill: "#399C97"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 46,
    y: 31,
    width: 133,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.4715ddd17bc97981dbe8dc8e573c6860.svg";
export { ForwardRef as ReactComponent };